export const VALIDATE_MATCH = 'VALIDATE_MATCH';
export const FLIP_CARD = 'FLIP_CARD';
export const GET_DECK = 'GET_DECK';
export const GET_ONLINE_DECK = 'GET_ONLINE_DECK';

